import config from './config/index';
export default config;
export * from './config/index';
